"use client";
import React, {useRef} from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {hardGray, softWhite, text} from '@/styles/globalStyleVars';
import Title from "@/components/common/ui/Title";
import {Img} from "@/components/common/ui/Img";
import reactHtmlParser from "react-html-parser";
import useContainerOffset from "@/components/hooks/useContainerOffset";
import PrevIcon from "@/components/common/ui/icons/PrevIcon";
import NextIcon from "@/components/common/ui/icons/NextIcon";
import Slider, {Slide} from "@/components/common/ui/swiper";
import styled from "styled-components";

const MyComponent = ({data}) => {

    const offset = useContainerOffset('.container') + 15;

    const SwiperRef = useRef();


    // Function to initialize swiper
    const handleSwiperInit = (swiper) => {
        return swiper;
    };



    return (
        <StyledComponent offset={offset} className={'awards pt-160 pb-160 no-line'}>
            <Container fluid className={'pr-0'}>
                <Row>
                    <Col md={4} className={'d-flex flex-column justify-content-between'}>
                        <div className="awards__top flex-column">
                            <Title fontWeight={400}
                                   margin={'0 0 20px'}
                                   text={data?.section_data?.subtitle}
                                   color={text}
                                   type={'h4'}
                            />
                            <p>
                                {data?.section_data?.short_desc}
                            </p>
                        </div>
                        <div className="blog-button">
                            <div className="slider-nav">
                                <ul>
                                    <li id={'slider_prev_award'} className={'slider_prev_award'}>
                                        <PrevIcon/>
                                    </li>
                                    <li id={'slider_next_award'} className={'slider_next_award'}>
                                        <NextIcon/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Col>
                    <Col className={'for-mobile-gap'} md={8}>

                        {data?.posts?.list?.length > 0 &&
                            <Slider
                                ref={SwiperRef}
                                navigationLeft={`#slider_next_award`}
                                navigationRight={`#slider_prev_award`}
                                autoplay={false}
                                grabCursor={false}
                                watchSlidesProgress={false}
                                mousewheelControl={false}
                                keyboardControl={false}
                                onSwiperInit={handleSwiperInit}
                                loop={false}
                                spaceBetween={30}
                                speed={1500}
                                breakpoints={{
                                        1024: {
                                            slidesPerView: 2,
                                            spaceBetween: 30,
                                        },
                                        992: {
                                            slidesPerView: 1,
                                            spaceBetween: 30,
                                        },
                                }
                                }
                            >


                                {data?.posts?.list?.map((e, index) => {
                                    let isLogo = e?.images?.find((f) => f?.thumb === 'on')


                                    return (
                                        <Slide key={index}>
                                            <div className="awards__slider">
                                                <div className="content">
                                                    <p className="year split-up">{e?.data?.subtitle}</p>
                                                    <p className={'split-up'}>{e?.data?.title}</p>
                                                </div>
                                                <div className={`awards__slider__item ${isLogo ? 'isLogo' : ''}`}>
                                                    <Img  src={e?.images?.[0]?.full_path} alt={e?.title}/>
                                                </div>

                                                <div className="content-bottom">
                                                    {reactHtmlParser(e?.data?.description)}
                                                </div>
                                            </div>
                                        </Slide>
                                    )
                                })}

                            </Slider>

                        }

                    </Col>
                </Row>
            </Container>
        </StyledComponent>
    )
        ;
};
const StyledComponent = styled.section`
    background-color: #FFFFFF;
    overflow: hidden;
    .container-fluid {
        padding-left: ${probs => probs.offset ? probs.offset : '90'}px;
    }

    h4 {
        font-weight: 400;

        strong {
            font-weight: 500;
        }
    }

    .awards__top {
        display: flex;
        justify-content: space-between;

        ul {
            display: flex;
        }

    }

    .blog-button {
        margin-bottom: 40px;
    }

    .awards__slider {
        width: 100%;
        background-color: ${softWhite};
        position: relative;
        border-radius: 10px;
        padding: 30px 40px;
        height: 100%;
        &__item {
            padding-top: calc(200 / 290 * 100%);
            position: relative;
            margin-bottom: 20px;
            @media(min-width: 1800px){
                padding-top: calc(270 / 290 * 100%);
                
            }
            &.isLogo{
                .global-image{
                    img{
                        object-fit: contain !important;
                        margin: auto;
                        height: 65px !important;
                        width: auto !important;
                    }
                }
            }

            .global-image {
                border-radius: 10px;
            }


        }

        .content {
            margin-bottom: 40px;

            p {
                color: ${text};
                margin-bottom: 0;
                margin-top: 0;

                &.year {
                    color: ${hardGray};
                    font-weight: 300;
                }
            }

        }

        .content-bottom {
            color: ${hardGray};
            line-height: 20px;

        }

    }

    .swiper-initialized {
        padding-right: ${p => p.offset}px;
    }

    @media (max-width: 767px) {
        .for-mobile-gap {
            padding-right: 0;
        }

        .swiper-initialized {
            padding-right: ${p => p.offset}px;
        }
    }


    @media (max-width: 990px) {
        .awards__top {
            flex-wrap: wrap;

            ul {
                width: 100%;
            }
        }
    }

    @media (max-width: 500px) {
        .swiper {
            padding-right: 80px;
        }
        
        .blog-button{
            margin-top: 40px;
        }
    }
`;
export default React.memo(MyComponent);